import React from 'react';
import {useLocation, useNavigate} from 'react-router';
import {WelcomeScreen} from '~/processes/onboarding';

function WelcomeScreenPage() {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <WelcomeScreen
            onGoToSignup={() => {
                navigate({
                    pathname: '/signup',
                    search: location.search,
                });
            }}
            onGoToLogin={() => {
                navigate('/login');
            }}
        />
    );
}

export default WelcomeScreenPage;
